import { createSelector } from 'reselect';
import { RootStateOrAny } from 'react-redux';
import { getEnvironmentSelector } from '@americanexpress/travel-selectors';
import { oneCmsInternetConfigLinks } from '../constants/commonConstants';

export const getHost = (state:RootStateOrAny) => state.getIn(['browser', 'location', 'host']);

export const getIsLocalhost = createSelector(
  getHost,
  (host: string) => host.includes('localhost')
);
export const oneCMSSSRUrl = createSelector(
  getEnvironmentSelector,
  (environment) => oneCmsInternetConfigLinks[environment as keyof typeof oneCmsInternetConfigLinks]
);

export const subnavScriptURLSelector = createSelector(
  getIsLocalhost,
  oneCMSSSRUrl,
  (isLocalHost, partialUrl) => {
    if (isLocalHost) {
      return 'http://localhost:8000/navScript.js';
    }
    return `${partialUrl}/Internet/travel/global-travel-navigation/travel-header-script/navScript.js`;
  });
